<template>
  <div class="marker-map">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="55"
      height="55"
      viewBox="0 0 55 55"
      class="marker-map__svg"
      v-if="isCompetitor"
    >
      <defs>
        <filter id="Ellipse_11" x="0" y="0" width="55" height="55" filterUnits="userSpaceOnUse">
          <feOffset input="SourceAlpha" />
          <feGaussianBlur stdDeviation="2" result="blur" />
          <feFlood flood-opacity="0.302" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Calque_2" data-name="Calque 2" transform="translate(-3.5 -3.5)">
        <g transform="matrix(1, 0, 0, 1, 3.5, 3.5)" filter="url(#Ellipse_11)">
          <circle
            id="Ellipse_11-2"
            data-name="Ellipse 11"
            cx="21"
            cy="21"
            r="21"
            transform="translate(6.5 6.5)"
            :fill="fill"
            :stroke="stroke"
            stroke-width="1"
          />
        </g>
      </g>
    </svg>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="55.001"
      height="64.191"
      viewBox="0 0 55.001 64.191"
      class="marker-map__svg"
      v-else
    >
      <defs>
        <filter id="Tracé_626" x="0" y="0" width="55.001" height="64.191" filterUnits="userSpaceOnUse">
          <feOffset input="SourceAlpha" />
          <feGaussianBlur stdDeviation="2" result="blur" />
          <feFlood flood-opacity="0.302" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="shop-4" transform="translate(-43.499 7.5)">
        <g transform="matrix(1, 0, 0, 1, 43.5, -7.5)" filter="url(#Tracé_626)">
          <path
            id="Tracé_626-2"
            data-name="Tracé 626"
            d="M71,50.09,52.445,37.72A5.375,5.375,0,0,1,50,33.11V4.444A5.45,5.45,0,0,1,55.444-1h31.11A5.45,5.45,0,0,1,92,4.444V33.11a5.933,5.933,0,0,1-2.375,4.56l-.034.027Z"
            transform="translate(-43.5 7.5)"
            :fill="fill"
            :stroke="stroke"
            stroke-width="1"
          />
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
import { generateColors } from '@/utils/colors.util'

export default {
  name: 'MarkerMap',
  props: {
    currentValue: {
      type: Number,
      required: true,
    },
    isCompetitor: {
      type: Boolean,
      required: false,
      default: false,
    },
    filters: {
      type: Array,
      required: true,
    },
  },
  computed: {
    fill() {
      return generateColors(this.currentValue, this.filters)
    },
    stroke() {
      return generateColors(this.currentValue, this.filters, true)
    },
  },
}
</script>

<style lang="scss" scoped>
.marker-map {
  display: inline-flex;

  &__svg {
    width: 100%;
    height: 100%;
  }
}
</style>
